module.exports = __webpack_public_path__ + "static/media/cookidoo_2.0-brochure-first-steps.dbc57c6c.pdf";